import { RootState } from 'store/rootReducer';

export const isInlineEditorEnabledSelector = (state: RootState) => state.Bot.configData.enable_inline_editor;

export const isRcsConfiguredSelector = (state: RootState) => state.Bot.data.is_rcs_configured;

export const rcsAgentId = (state: RootState) => state.Bot.data.rcs_agent_id;
